import { render, staticRenderFns } from "./realname.vue?vue&type=template&id=651bd6e9&scoped=true&"
import script from "./realname.vue?vue&type=script&lang=js&"
export * from "./realname.vue?vue&type=script&lang=js&"
import style0 from "./realname.vue?vue&type=style&index=0&id=651bd6e9&scoped=true&lang=less&"
import style1 from "./realname.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651bd6e9",
  null
  
)

export default component.exports